// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.agro-insurance .cpf-mask-color {
  color: var(--color-neutral-dark);
}
.agro-insurance .state-selector {
  margin-top: 8px;
}
.rc-virtual-list-holder {
  padding-bottom: 21px;
}
`, "",{"version":3,"sources":["webpack://./src/Assets/styles/default/components/Product/QuotationModal/AgroInsurance.less"],"names":[],"mappings":"AAAA;EAEI,gCAAA;AAAJ;AAFA;EAMI,eAAA;AADJ;AAKA;EACE,oBAAA;AAHF","sourcesContent":[".agro-insurance {\n  .cpf-mask-color {\n    color: var(--color-neutral-dark);\n  }\n\n  .state-selector {\n    margin-top: 8px;\n  }\n}\n\n.rc-virtual-list-holder {\n  padding-bottom: 21px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
